// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post__content table td,
.post__content table th,
.post--content table td,
.post--content table th {
  min-width: 4em;
  word-break: normal;
}
.post__content .callout,
.post--content .callout {
  padding: 16px;
  color: #2B3346;
  margin: 8px 0;
}
.post__content .callout p:last-child,
.post--content .callout p:last-child {
  margin-bottom: 0;
}
.post__content img:not([src*=emojione]),
.post--content img:not([src*=emojione]) {
  cursor: pointer;
}
.post__content pre,
.post--content pre {
  white-space: pre-wrap;
}

.callout-green {
  background-color: rgba(108, 190, 147, 0.2);
  border-left: 4px solid #6CBE93;
}

.callout-blue {
  background-color: rgba(108, 166, 252, 0.2);
  border-left: 4px solid #6CA6FC;
}

.callout-yellow {
  background-color: rgba(248, 191, 112, 0.2);
  border-left: 4px solid #F8BF70;
}

.callout-red {
  background-color: rgba(248, 109, 112, 0.2);
  border-left: 4px solid #F86D70;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.cke_panel_listItem {
  color: #181f26;
}

.cke_panel_listItem .sr-only {
  position: relative;
  color: inherit;
  width: auto;
  height: auto;
  clip: unset;
}

.cke_editable .sr-only {
  position: relative;
  border: 1px dashed #999;
  padding: 1rem;
  margin: 1rem 0;
  width: auto;
  height: auto;
  clip: unset;
  background-color: #f9f9f9;
  color: inherit;
  overflow: unset;
}
.cke_editable .sr-only::after {
  content: "Visible for screen readers only";
  position: absolute;
  top: -0.75rem;
  left: 0.5rem;
  background: #fff;
  padding: 0 0.25rem;
  font-size: 0.75rem;
  font-weight: bold;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  white-space: nowrap;
}

.callout-gray {
  background-color: rgba(190, 193, 200, 0.2);
  border-left: 4px solid #BEC1C8;
}

.cke_panel_container,
.post__content.post__content--new-editor {
  font-family: var(--config--main-font-base-stack);
  font-size: 14px;
}
.cke_panel_container.cke_editable,
.post__content.post__content--new-editor.cke_editable {
  background-color: #fff;
  height: auto !important;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-left: 0;
}
.cke_panel_container h1,
.post__content.post__content--new-editor h1 {
  font-weight: 300;
  font-size: 24px;
  line-height: 125%;
  letter-spacing: 0.25px;
}
.cke_panel_container h2,
.post__content.post__content--new-editor h2 {
  font-weight: normal;
  font-size: 20px;
  line-height: 125%;
  letter-spacing: 0.01em;
}
.cke_panel_container h3,
.post__content.post__content--new-editor h3 {
  font-size: 16px;
}
.cke_panel_container figure img,
.post__content.post__content--new-editor figure img {
  margin: 0 auto;
  display: block;
  max-width: 100%;
}
@media only screen and (min-width: 768px) {
  .cke_panel_container figure img,
  .post__content.post__content--new-editor figure img {
    max-height: 600px;
  }
}
.cke_panel_container blockquote,
.post__content.post__content--new-editor blockquote {
  border-left: 2px solid #d5d9de;
}
.cke_panel_container code,
.post__content.post__content--new-editor code {
  background: #f6f6f6;
  color: #F84E78;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 2px;
  border-radius: 0;
}
.cke_panel_container a,
.post__content.post__content--new-editor a {
  color: var(--config--main-color-brand);
}
.cke_panel_container figure figcaption,
.post__content.post__content--new-editor figure figcaption {
  background: none;
  color: var(--config-meta-text-color);
}
.cke_panel_container table,
.post__content.post__content--new-editor table {
  display: block;
  overflow-x: auto;
  border: 0 !important;
}
.cke_panel_container th,
.post__content.post__content--new-editor th {
  background-color: #f6f6f6;
}
.cke_panel_container td, .cke_panel_container th,
.post__content.post__content--new-editor td,
.post__content.post__content--new-editor th {
  padding: 12px 16px;
  border: 1px solid #d5d6da;
}
.cke_panel_container .placeholder,
.post__content.post__content--new-editor .placeholder {
  color: var(--config-main-navigation-search-placeholder-color);
}

input-variable {
  background-color: #f6f6f6;
  border: 1px solid #959898;
  border-radius: 4px;
  color: #959898;
  display: inline-block;
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  line-height: 1.5;
  padding: 0 6px;
}

.post__content--new-editor {
  display: flow-root;
}
.post__content--new-editor.post__content--email table {
  background: none;
  background-color: transparent;
  display: table;
  margin-inline-start: auto;
  margin-inline-end: auto;
}
.post__content--new-editor.post__content--email th, .post__content--new-editor.post__content--email td {
  border: 0;
  padding: 0;
  min-width: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
